import { render, staticRenderFns } from "./EmdFooterIcon.vue?vue&type=template&id=2861be18"
import script from "./EmdFooterIcon.vue?vue&type=script&lang=js"
export * from "./EmdFooterIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2861be18')) {
      api.createRecord('2861be18', component.options)
    } else {
      api.reload('2861be18', component.options)
    }
    module.hot.accept("./EmdFooterIcon.vue?vue&type=template&id=2861be18", function () {
      api.rerender('2861be18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/atoms/EmdFooterIcon.vue"
export default component.exports